// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pill {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 1em;
}
.pill > label {
  font-size: 1em;
}
.pill > select {
  width: 5em;
  height: 3em;
  border: none;
  background-color: #f3f3f3;
  color: #050505;
  font-size: 1rem;
  font-weight: 600;
  padding: 0.5rem;
  border-radius: 4px;
  cursor: pointer;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  -o-appearance: none;
}

.container input[type=radio]:checked + label {
  color: #f3f3f3;
}

.container input[id=radio-1]:checked ~ .glider {
  transform: translateX(0);
}

.container input[id=radio-2]:checked ~ .glider {
  transform: translateX(100%);
}

.container input[id=radio-3]:checked ~ .glider {
  transform: translateX(200%);
}

.container input[id=radio-4]:checked ~ .glider {
  transform: translateX(300%);
}

.glider {
  position: absolute;
  display: flex;
  height: 30px;
  width: 50px;
  border: 1px solid #ffc917;
  color: #f3f3f3;
  z-index: 1;
  border-radius: 99px;
  transition: 0.25s ease-out;
}

@media (max-width: 700px) {
  .tabs {
    transform: scale(0.6);
  }
}
@media (min-width: 390px) {
  .pill > label {
    font-size: 2em;
  }
  .shop_modals_item_info {
    gap: 0;
  }
}
@media (min-width: 768px) {
  .pill > label {
    font-size: 1em;
  }
  .pill > select {
    height: 2em;
  }
  .shop_modals_item_info {
    gap: 4em;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/pill/styles.scss","webpack://./src/assets/scss/components/_colors.scss","webpack://./src/assets/scss/components/_mixins.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AADF;AAGE;EACE,cAAA;AADJ;AAGE;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA,yBCVQ;EDWR,cCbQ;EDcR,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;AADJ;;AAKA;EACE,cC3BU;ADyBZ;;AAKA;EACE,wBAAA;AAFF;;AAKA;EACE,2BAAA;AAFF;;AAKA;EACE,2BAAA;AAFF;;AAKA;EACE,2BAAA;AAFF;;AAKA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EAEA,yBAAA;EACA,cCrDU;EDsDV,UAAA;EACA,mBAAA;EACA,0BAAA;AAHF;;AAMA;EACE;IACE,qBAAA;EAHF;AACF;AEzDE;EFiEE;IACE,cAAA;EALJ;EASA;IACE,MAAA;EAPF;AACF;AE3DE;EFuEE;IACE,cAAA;EATJ;EAYE;IACE,WAAA;EAVJ;EAcA;IACE,QAAA;EAZF;AACF","sourcesContent":["@import \"../../assets/scss/combined.scss\";\n\n.pill {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 1em;\n\n  & > label {\n    font-size: 1em;\n  }\n  & > select {\n    width: 5em;\n    height: 3em;\n    border: none;\n    background-color: $bdt-white;\n    color: $bdt-black;\n    font-size: 1rem;\n    font-weight: 600;\n    padding: 0.5rem;\n    border-radius: 4px;\n    cursor: pointer;\n    outline: none;\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    -ms-appearance: none;\n    -o-appearance: none;\n  }\n}\n\n.container input[type=\"radio\"]:checked + label {\n  color: $bdt-white;\n}\n\n.container input[id=\"radio-1\"]:checked ~ .glider {\n  transform: translateX(0);\n}\n\n.container input[id=\"radio-2\"]:checked ~ .glider {\n  transform: translateX(100%);\n}\n\n.container input[id=\"radio-3\"]:checked ~ .glider {\n  transform: translateX(200%);\n}\n\n.container input[id=\"radio-4\"]:checked ~ .glider {\n  transform: translateX(300%);\n}\n\n.glider {\n  position: absolute;\n  display: flex;\n  height: 30px;\n  width: 50px;\n  //   background-color: $bdt-black;\n  border: 1px solid $bdt-gold;\n  color: $bdt-white;\n  z-index: 1;\n  border-radius: 99px;\n  transition: 0.25s ease-out;\n}\n\n@media (max-width: 700px) {\n  .tabs {\n    transform: scale(0.6);\n  }\n}\n\n@include screen-sm {\n  .pill {\n    & > label {\n      font-size: 2em;\n    }\n  }\n\n  .shop_modals_item_info {\n    gap: 0;\n  }\n}\n\n@include screen-md {\n  .pill {\n    & > label {\n      font-size: 1em;\n    }\n\n    & > select {\n      height: 2em;\n    }\n  }\n\n  .shop_modals_item_info {\n    gap: 4em;\n  }\n}\n","$bdt-yellow-gold: #ffe100;\n$bdt-gold: #ffc917;\n$bdt-red: #f00000;\n$bdt-dark-red: #8c0000;\n$bdt-black: #050505;\n$bdt-gray: #88888a;\n$bdt-white: #f3f3f3;\n$bdt-green: #37ff8b;\n\n","$screen-sm: 390px;\n$screen-md: 768px;\n$screen-lg: 1024px;\n$screen-xl: 1280px;\n$screen-2xl: 1640px;\n$screen-3xl: 1920px;\n\n@mixin screen-sm {\n  @media (min-width: $screen-sm) {\n    @content;\n  }\n}\n\n@mixin screen-md {\n  @media (min-width: $screen-md) {\n    @content;\n  }\n}\n\n@mixin screen-lg {\n  @media (min-width: $screen-lg) {\n    @content;\n  }\n}\n\n@mixin screen-xl {\n  @media (min-width: $screen-xl) {\n    @content;\n  }\n}\n\n@mixin screen-2xl {\n  @media (min-width: $screen-2xl) {\n    @content;\n  }\n}\n\n@mixin screen-3xl {\n  @media (min-width: $screen-3xl) {\n    @content;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
